require('./angular/app');
require('./angular/services/ABCFilterModal');
require('./angular/services/Content');
require('./angular/services/Favourite');
require('./angular/services/LicencingFormModal');
require('./angular/services/Locale');
require('./angular/services/Office');
require('./angular/services/SelectOfficeModal');
require('./angular/services/Site');
require('./angular/services/Synch');
require('./angular/services/TerritoryControl');
require('./angular/services/Nps');
require('./angular/services/Track');
require('./angular/services/TrackInfoModal');
require('./angular/directives/focus');
require('./angular/directives/favourite');
require('./angular/directives/hoverSpy');
require('./angular/directives/multiImg');
require('./angular/directives/paralaxTop');
require('./angular/directives/playPanel');
require('./angular/directives/routeLoaderMask');
require('./angular/directives/satvInViewport');
require('./angular/directives/slideshow');
require('./angular/directives/socialIcons');
require('./angular/directives/songwriterGrid');
require('./angular/directives/tiles');
require('./angular/directives/videoPlayer');
require('./angular/directives/skipToMainContent');
require('./angular/filters/asset');
require('./angular/filters/sanitizeId');
require('./angular/controllers/AboutCtrl');
require('./angular/controllers/ContactCtrl');
require('./angular/controllers/EMIPolandCtrl');
require('./angular/controllers/FeaturedPlaylistCtrl');
require('./angular/controllers/FooterCtrl');
require('./angular/controllers/HomeCtrl');
require('./angular/controllers/LoginCtrl');
require('./angular/controllers/LogoutCtrl');
require('./angular/controllers/MainMenuCtrl');
require('./angular/controllers/NavbarCtrl');
require('./angular/controllers/NewsArticleCtrl');
require('./angular/controllers/NewsCtrl');
require('./angular/controllers/SelectOfficeModalCtrl');
require('./angular/controllers/ServicesCtrl');
require('./angular/controllers/SiteMenu');
require('./angular/controllers/SongwriterProfileCtrl');
require('./angular/controllers/SongwritersCtrl');
require('./angular/controllers/SynchCtrl');
require('./angular/controllers/SynchEnquiryModalCtrl');
require('./angular/controllers/TrackInfoModalCtrl');


// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/index.js